import { render } from "./Main.vue?vue&type=template&id=a44ea8e2"
const script = {}
script.render = render

export default script